import { useQuery } from '@tanstack/react-query';
import { reportsApi } from '../services/api';

const hasValue = (v) => {
  if (Array.isArray(v)) return v.length > 0;
  return !!v;
};

export const useAplSearch = (filters = {}, options = {}) => {
  const { enabled = true } = options;

  const hasSearchCriteria = !!(
    hasValue(filters.search) ||
    hasValue(filters.upcCode) ||
    hasValue(filters.productName) ||
    hasValue(filters.manufacturer) ||
    hasValue(filters.sku) ||
    hasValue(filters.industry) ||
    hasValue(filters.fisCat) ||
    hasValue(filters.fisSubcatDesc) ||
    hasValue(filters.campaignCode) ||
    hasValue(filters.fileName)
  );

  return useQuery({
    queryKey: ['aplSearch', filters],
    queryFn: () => reportsApi.searchAplProducts(filters),
    enabled: enabled && hasSearchCriteria,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useAplFilterOptions = (options = {}) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: ['aplFilterOptions'],
    queryFn: () => reportsApi.getAplFilterOptions(),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
